/* eslint-disable @typescript-eslint/no-explicit-any */
import { LocalCache } from 'apollo-client';
import { ListingFilters } from 'generated/graphql';
type FiltersToUpdate = Exclude<keyof ListingFilters, '__typename'>;
type CalculatedFiltersToUpdate = Extract<keyof LocalCache, 'prediction' | 'comparison'>;

const filtersToUpdate: ReadonlyArray<CalculatedFiltersToUpdate | FiltersToUpdate> = [
  'modelNames',
  'optionals',
  'vendorType',
  'brandNames',
  'powerSupplies',
  'gearTypes',
  'tractionTypes',
  'regions',
  'provinces',
  'interiorColors',
  'coatingColors',
  'isPriceTiedToLoan',
  'isVATDeductible',
  'isPictureAvailable',
  'isVehicleCoveredByWarranty',
  'priceLabels',
  'modelVersions',
  'vehicleKM',
  'vehicleRegistrationDateISO8601',
  'vehicleTypes',
  'websites',
  'powerInHP',
  'engineDisplacementInCM3',
  'priceInEUR',
  'vendorNames',
  'comparison',
  'prediction',
] as const;

export const applyFiltersGroup: (p: { filters: ListingFilters; onError: (error: unknown) => void }) => void = async ({
  filters,
  onError,
}) => {
  try {
    const C = await import('cache');
    const KeyOfFilters = Object.keys(filters).filter((x) =>
      filtersToUpdate.includes(x as typeof filtersToUpdate[number])
    );

    KeyOfFilters.map(async (f) => {
      const filter = f as keyof ListingFilters;
      const currentValue = filters?.[filter];
      switch (filter) {
        /* theese filters have 3 states ( true | false | undefined ) */
        case 'isVehicleCoveredByWarranty':
        case 'vehicleTypes':
        case 'isPictureAvailable':
        case 'isVATDeductible':
        case 'isPriceTiedToLoan': {
          if (currentValue === null) return await (C as any)?.[filter](undefined);
          return await (C as any)?.[filter](currentValue);
        }
        case 'modelVersions': {
          return await (C as any)?.[filter](
            (currentValue as ReadonlyArray<string>)?.map((x) => ({ label: x, value: x }))
          );
        }
        case 'vehicleRegistrationDateISO8601': {
          /* skip nullable */
          const currentVehicleRegistrationDateISO8601: ListingFilters['vehicleRegistrationDateISO8601'] =
            currentValue as ListingFilters['vehicleRegistrationDateISO8601'];
          if (!currentVehicleRegistrationDateISO8601?.min || !currentVehicleRegistrationDateISO8601?.max) return null;
          return await (C as any)?.[filter](currentVehicleRegistrationDateISO8601);
        }
        default: {
          return await (C as any)?.[filter](currentValue);
        }
      }
    });
  } catch (error) {
    onError(error);
  }
};
